import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { JourneyPage } from "../../components/travel-journeys/journey-page";
import { journeysSearchShape } from "../../components/travel-journeys/journeys-search";

/**
 * `/logistics/arrival-departure/journeys/arrival/f:<uuid>` — one journey's
 * page (M9b §1, her `pgSch` as a full page). `$direction` is `arrival` |
 * `departure`; `$groupKey` the journey's opaque `group_key` (the router
 * encodes it). It accepts the list's search keys so the back arrow
 * (`search: true`) restores the list.
 */
export const Route = createFileRoute("/_app/logistics/arrival-departure/journeys/$direction/$groupKey")({
	validateSearch: z.object(journeysSearchShape),
	component: JourneyRoute,
});

function JourneyRoute() {
	const { session } = Route.useRouteContext();
	const { direction, groupKey } = Route.useParams();
	return <JourneyPage session={session} direction={direction} groupKey={groupKey} search={Route.useSearch()} />;
}
